{
    "Profile_Documents.documents": "FR: Documents",
    "Profile_Documents.action": "FR: Action",
    "Profile_Documents.refreshDocuments": "FR: Refresh Documents",
    "Profile_Documents.generateDocument": "FR: Generate Document",
    "Profile_Documents.sendEmailToClient": "FR: Send Email to Client",
    "Profile_Documents.shareDocuments": "FR: Share Documents",
    "Profile_Documents.regenerateDocuments": "FR: Regenerate Documents",
    "Profile_Documents.policyDocuments": "FR: Policy Documents",
    "Profile_Documents.shared": "FR: Shared",
    "Profile_Documents.upload": "FR: Upload",
    "Profile_Documents.policyAttachments": "FR: Policy Attachments",
    "Profile_Documents.template": "FR: Template:",
    "Profile_Documents.documentsOptional": "FR: Documents (optional)",
    "Profile_Documents.cancel": "FR: Cancel",
    "Profile_Documents.send": "FR: Send",
    "Profile_Documents.regenerate": "FR: Regenerate",
    "Profile_Documents.selectWhatToGenerate": "FR: Please select what you want to generate",
    "Profile_Documents.generate": "FR: Generate",
    "Profile_Documents.apply": "FR: Apply",
    "Profile_Documents.reason": "FR: Reason:",
    "Profile_Documents.Input.reasonPlaceholder": "FR: Enter your reason here"
}
